import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStylesV2 } from '@kubit/web-ui-product-components';
// Components
import { DetailComponent } from '../detail/detail.component';
import { ParagraphComponent } from '../paragraph';
// Constants
import { STYLES_NAME } from '../../constants/stylesName';
// Enumerations
import { DetailConfirmationVariantsEnum } from '../../designSystem/reloaded/commons/components/detail-confirmation';
// Styles
import { DetailConfirmationComponentStyled, DetailConfirmationDetailsContainerStyled, } from './detail-confirmation.component.styled';
export const DetailConfirmationComponent = ({ title, details, variant = DetailConfirmationVariantsEnum.TWO_COLUMN_DEFAULT, paragraph, detailsAlignment, }) => {
    const styles = useStylesV2({
        styleName: STYLES_NAME.DETAIL_CONFIRMATION,
        variantName: variant,
    });
    return (_jsxs(DetailConfirmationComponentStyled, { styles: styles, children: [title && (_jsx(ParagraphComponent, { component: title.component, customTypography: styles?.header, children: title.title })), _jsx(DetailConfirmationDetailsContainerStyled, { styles: styles, children: details.map((detail, index) => (_createElement(DetailComponent, { alignment: detailsAlignment, ...detail, key: index }))) }), paragraph && (_jsx(ParagraphComponent, { customTypography: styles?.paragraph, children: paragraph }))] }));
};
//# sourceMappingURL=detail-confirmation.component.js.map